import React from 'react';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/Dialog';
export function FooterSection() {
  return <footer className="w-full bg-[#1B4332] py-8" data-id="element-64">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-65">
        <div className="flex flex-col items-center gap-4" data-id="element-66">
          <div className="flex items-center gap-6" data-id="element-67">
            <Dialog data-id="element-68">
              <DialogTrigger className="text-white/70 hover:text-white text-sm underline-offset-4 hover:underline transition-colors cursor-pointer" data-id="element-69">
                Política de Privacidad
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-id="element-70">
                <DialogHeader data-id="element-71">
                  <DialogTitle data-id="element-72">Política de Privacidad</DialogTitle>
                  <DialogDescription data-id="element-73">
                    Última actualización: Abril 2026
                  </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-74">
                  <h3 className="font-semibold text-base text-gray-900" data-id="element-75">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-76">
                    Recopilamos la información que nos proporcionas directamente
                    al realizar una compra, incluyendo tu nombre, dirección de
                    correo electrónico y datos de pago. Los datos de pago son
                    procesados de forma segura por nuestro proveedor de pagos y
                    no almacenamos información de tarjetas de crédito en
                    nuestros servidores.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-77">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-78">
                    Utilizamos tu información personal exclusivamente para
                    procesar tu pedido, enviarte el producto digital adquirido y
                    comunicarnos contigo sobre tu compra. No vendemos,
                    alquilamos ni compartimos tu información personal con
                    terceros con fines de marketing.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-79">
                    3. Cookies y Tecnologías de Seguimiento
                  </h3>
                  <p data-id="element-80">
                    Nuestro sitio web puede utilizar cookies esenciales para el
                    funcionamiento básico del sitio y cookies analíticas para
                    comprender cómo los visitantes interactúan con nuestra
                    página. Puedes desactivar las cookies en la configuración de
                    tu navegador.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-81">
                    4. Seguridad de los Datos
                  </h3>
                  <p data-id="element-82">
                    Implementamos medidas de seguridad técnicas y organizativas
                    apropiadas para proteger tu información personal contra el
                    acceso no autorizado, la alteración, divulgación o
                    destrucción.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-83">
                    5. Tus Derechos
                  </h3>
                  <p data-id="element-84">
                    Tienes derecho a acceder, rectificar o eliminar tus datos
                    personales en cualquier momento. También puedes solicitar la
                    portabilidad de tus datos o limitar su procesamiento
                    conforme a la normativa vigente de protección de datos
                    (RGPD).
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-85">
                    6. Cambios en esta Política
                  </h3>
                  <p data-id="element-86">
                    Nos reservamos el derecho de actualizar esta política de
                    privacidad en cualquier momento. Cualquier cambio será
                    publicado en esta página con la fecha de actualización
                    correspondiente.
                  </p>
                </div>
              </DialogContent>
            </Dialog>

            <span className="text-white/30" data-id="element-87">|</span>

            <Dialog data-id="element-88">
              <DialogTrigger className="text-white/70 hover:text-white text-sm underline-offset-4 hover:underline transition-colors cursor-pointer" data-id="element-89">
                Términos y Condiciones
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-id="element-90">
                <DialogHeader data-id="element-91">
                  <DialogTitle data-id="element-92">Términos y Condiciones</DialogTitle>
                  <DialogDescription data-id="element-93">
                    Última actualización: Abril 2026
                  </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-94">
                  <h3 className="font-semibold text-base text-gray-900" data-id="element-95">
                    1. Aceptación de los Términos
                  </h3>
                  <p data-id="element-96">
                    Al acceder a este sitio web y realizar una compra, aceptas
                    estos términos y condiciones en su totalidad. Si no estás de
                    acuerdo con alguno de estos términos, te rogamos que no
                    utilices nuestro sitio ni adquieras nuestros productos.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-97">
                    2. Producto Digital
                  </h3>
                  <p data-id="element-98">
                    El producto ofrecido es una guía digital en formato PDF. Una
                    vez completada la compra, recibirás acceso inmediato para
                    descargar el material. El contenido es exclusivamente para
                    uso personal y no puede ser redistribuido, revendido ni
                    compartido sin autorización expresa.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-99">
                    3. Precio y Pago
                  </h3>
                  <p data-id="element-100">
                    El precio del producto se muestra en dólares estadounidenses
                    (USD). El pago se realiza de forma única, sin suscripciones
                    ni cargos recurrentes. Todos los pagos son procesados de
                    forma segura a través de nuestro proveedor de pagos
                    autorizado.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-101">
                    4. Política de Reembolso
                  </h3>
                  <p data-id="element-102">
                    Debido a la naturaleza digital del producto, una vez
                    descargado no se aceptan devoluciones. Sin embargo, si
                    experimentas problemas técnicos con la descarga, nos
                    comprometemos a resolverlos para garantizar que recibas tu
                    producto.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-103">
                    5. Propiedad Intelectual
                  </h3>
                  <p data-id="element-104">
                    Todo el contenido de este sitio web y del producto digital,
                    incluyendo textos, imágenes, diseños y logotipos, está
                    protegido por derechos de autor. Queda prohibida su
                    reproducción total o parcial sin consentimiento previo por
                    escrito.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-105">
                    6. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-106">
                    Los resultados obtenidos con la guía pueden variar según las
                    condiciones individuales de cada usuario (clima, espacio,
                    dedicación). No garantizamos resultados específicos. La
                    información proporcionada es de carácter educativo y
                    orientativo.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-107">
                    7. Legislación Aplicable
                  </h3>
                  <p data-id="element-108">
                    Estos términos se rigen por la legislación vigente.
                    Cualquier disputa será resuelta ante los tribunales
                    competentes de la jurisdicción correspondiente.
                  </p>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          <p className="text-white/50 text-xs" data-id="element-109">
            © {new Date().getFullYear()} Maestría en Huerto Urbano. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}